/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ExportAllAgecStatsMutationResponse,
  ExportAllAgecStatsQueryParams,
} from "../types/ExportAllAgecStats.ts"

export const exportAllAgecStatsMutationKey = () =>
  [{ url: "/v1/product/export-all-agec-stats" }] as const

export type ExportAllAgecStatsMutationKey = ReturnType<
  typeof exportAllAgecStatsMutationKey
>

/**
 * @summary Export all AGEC stats
 * {@link /v1/product/export-all-agec-stats}
 */
export async function exportAllAgecStats(
  params: ExportAllAgecStatsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ExportAllAgecStatsMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/product/export-all-agec-stats`,
    params,
    ...requestConfig,
  })
  return res
}

export function exportAllAgecStatsMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = exportAllAgecStatsMutationKey()
  return mutationOptions<
    ResponseConfig<ExportAllAgecStatsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: ExportAllAgecStatsQueryParams },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return exportAllAgecStats(params, config)
    },
  })
}

/**
 * @summary Export all AGEC stats
 * {@link /v1/product/export-all-agec-stats}
 */
export function useExportAllAgecStats<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ExportAllAgecStatsMutationResponse>,
      ResponseErrorConfig<Error>,
      { params: ExportAllAgecStatsQueryParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? exportAllAgecStatsMutationKey()

  const baseOptions = exportAllAgecStatsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ExportAllAgecStatsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: ExportAllAgecStatsQueryParams },
    TContext
  >

  return useMutation<
    ResponseConfig<ExportAllAgecStatsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: ExportAllAgecStatsQueryParams },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ExportAllAgecStatsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params: ExportAllAgecStatsQueryParams },
    TContext
  >
}
